import { render, staticRenderFns } from "./BespokeGrid.vue?vue&type=template&id=42b01bb8&"
import script from "./BespokeGrid.vue?vue&type=script&lang=js&"
export * from "./BespokeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports